// trace-counts.js

import get from "lodash/get";
import moment from "moment";
import { createSelector } from "reselect";
import { put, call, takeEvery } from "redux-saga/effects";

import { getWithStatusCheck, encodeUrl } from "../helpers/fetch.js";

import { getService } from "../selectors/service";

export const INITIAL_STATE = {
  isFetching: false,
  byId: {},
  byType: {},
  allIds: [],
};

// action types
// fetchTraceCount retrieves TraceCount for one entity, for use on the detail pages
const FETCH = "trace-web/trace-counts/FETCH";
const FETCH_SUCCESS = "trace-web/trace-counts/FETCH_SUCCESS";

// one fetch_failure works for both the above because we don't do anything in the event
// of a failure
const FETCH_FAILURE = "trace-web/trace-counts/FETCH_FAILURE";

// action creators
export const fetchTraceCount = (orgId, svcId, start, end, traceType) => {
  return {
    type: FETCH,
    orgId,
    svcId,
    start,
    end,
    traceType,
  };
};

export const fetchSuccess = (results, type) => {
  return {
    type: FETCH_SUCCESS,
    service: results.service,
    traceType: type,
  };
};

const fetchFailure = error => {
  return {
    type: FETCH_FAILURE,
    error,
  };
};

// reducer
const traceCountsReducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case FETCH: {
      return {
        ...state,
        isFetching: true,
        errors: [],
      };
    }
    case FETCH_SUCCESS: {
      const svc = action.service;
      const traceType = action.traceType;
      const byId = {
        ...state.byId,
        [svc.name]: svc,
      };
      const byType = {
        ...state.byType,
      };
      byType[`${svc.name}/${traceType}`] = svc;
      return {
        ...state,
        isFetching: false,
        byId: byId,
        byType: byType,
        allIds: Object.keys(byId).sort(),
      };
    }
    default: {
      return state;
    }
  }
};

export default traceCountsReducer;

// saga watchers
export function* traceCountsWatcher() {
  yield takeEvery(FETCH, traceCountsWorker);
}

// saga workers
function* traceCountsWorker(action) {
  const type = action.traceType;
  try {
    const url_tmpl = `/v1/apm/services/${action.svcId}/traces/count`;
    const url = encodeUrl(url_tmpl, {
      start_time: moment(action.start).unix(),
      end_time: moment(action.end).unix(),
      type: type,
    });
    const json = yield call(getWithStatusCheck, url);
    yield put(fetchSuccess(json, type));
  } catch (err) {
    yield put(fetchFailure(err));
  }
}

// selectors
export const getTraceCountsByServiceId = state =>
  state.entities.traceCounts.byId;

export const getTracesCountsByServiceType = state =>
  state.entities.traceCounts.byType;

const getTraceType = (_, props) => props.type;

export const getTraceCount = createSelector(
  [getTraceCountsByServiceId, getService],
  (traceCountsByServiceId, service) =>
    get(traceCountsByServiceId, [service, "traceCount"])
);

export const getTraceCountByType = createSelector(
  [getTracesCountsByServiceType, getService, getTraceType],
  (traceCounts, service, type) =>
    get(traceCounts, [`${service}/${type}`, "traceCount"])
);

export const getTraceCountsIsLoading = state =>
  !state.entities.traceCounts.isFetching;
